<div
  class="ui vertical segment"
  [ngClass]="{ loading: pending }"
  appPadding="0"
>
  <div
    id="no-radius"
    fxLayout="row"
    appMargin
    class="ui basic segment"
    marginB="3"
    fxLayoutGap="10px"
    fxLayoutAlign="start stretch"
  >
    <!-- <div fxFlex="3%">
      <sui-checkbox> </sui-checkbox>
    </div> -->
    <!-- <div fxFlex="22%">TRANSACTION ID</div> -->
    <div fxFlex="10%">CREDITED AMOUNT</div>
    <div fxFlex="10%">DEBITED AMOUNT</div>
    <div fxFlex="grow">DESCRIPTION</div>
    <div fxFlex="10%">STATUS</div>
    <div fxFlex="15%">TRANSACTION DATE</div>
    <div fxFlex="8%"></div>
  </div>
  <div
    class="ui basic segment"
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="15px"
    *ngFor="let unit of payments"
  >
    <!-- <div fxFlex="3%">
      <sui-checkbox
        (checkChange)="onChange($event, unit)"
        [(ngModel)]="unit.selected"
      ></sui-checkbox>
    </div> -->
    <!-- <div fxFlex="22%">{{ unit?.invoiceTransactionAccountId }}</div> -->
    <div fxFlex="10%">
      {{ currency }} {{ unit?.creditAmount | number: ".2-2" }}
    </div>
    <div fxFlex="10%">
      {{ currency }} {{ unit?.debitAmount | number: ".2-2" }}
    </div>
    <div fxFlex="grow">{{ unit?.remark }}</div>
    <div fxFlex="10%">
      <span class="ui label" [ngClass]="{ green: unit.status == 'OKAY' }">{{
        unit?.status
      }}</span>
    </div>
    <div fxFlex="15%">{{ unit?.dateCreated | date }}</div>
    <div fxFlex="8%" class="text-right">
      <button class="ui circular tiny button" (click)="view(unit)">
        <i class="eye icon"></i>
      </button>
    </div>
  </div>
  <app-no-record-found
    *ngIf="payments && payments.length < 1"
  ></app-no-record-found>
</div>
